<template>
  <div class="image-uploader">
    <div
      :class="['image-container relative border rounded flex justify-center items-center',{ 'hide': imageFile} ]"
    >

      <!-- To Show Image -->
      <img
        v-if="imagePreview"
        :src="logoImageSrc"
      />
      <div
        v-else
        class="upload-icon-container flex items-center justify-center cursor-pointer"
        @click.stop="selectFile(imageId)"
      >
        <img
          :src="logoImageSrc"
          class="default-image"
        />
      </div>

      <!-- To Change Image -->
      <div
        v-if="imagePreview"
        class="edit-icon-container rounded-full cursor-pointer absolute"
        @click.stop="selectFile(imageId)"
      >
        <span class="flex justify-center items-center h-full">
          <i class="fa fa-edit" />
        </span>
      </div>

      <!-- To Delete already uploaded Image -->
      <div
        v-if="imagePreview"
        class="delete-icon-container rounded-full cursor-pointer absolute"
        @click.stop="remove(imageId)"
      >
        <span class="flex justify-center items-center h-full">
          <i
            class="fa fa-close"
          />
        </span>
      </div>
      <!-- imageFile && !imageFile.name -->

      <input
        ref="imageFile"
        :id="imageId"
        class="hidden"
        type="file"
        accept=".jpg,.png,.jpeg,.gif"
        @change="handleUploadImage($event)"
      />
    </div>

    <!-- <pt-form-group
      v-if="imageFile && imageFile.name"
      :invalid-feedback="imageSizeError"
      class="sm:w-full sm:pr-4 lg:pr-0 lg:w-full lg:mb-0"
    >
      <div class="flex items-center w-full bg-grey-lighter">
        <pt-form-input
          :value="imageFile ? imageFile.name : ''"
          :disabled="true"
          name="imageFile"
          type="text"
          class="w-11/12 py-2 image-form-input"
          placeholder="Upload Logo Image"
        />
        <i
          v-if="imageFile"
          class="flex justify-center fa fa-times text-red w-1/12 mx-1 cursor-pointer"
          @click="remove(imageId)"
        />
      </div>
    </pt-form-group> -->
  </div>
</template>

<script>
import appConfig from '@src/app.config.js';

export default {
  props: {
    imageId: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: 'x',
    },
    uploadedImage: {
      type: [String, File],
      default: null,
    },
  },
  data() {
    return {
      imagePreview: this.uploadedImage || null,
      imageFile: null,
      imageSizeError: '',
    };
  },
  computed: {
    logoImageSrc() {
      return this.imagePreview
        ? this.imagePreview
        : require('@assets/images/img-upload.svg');
    },
  },
  watch: {
    uploadedImage(newVal, oldVal) {
      this.imagePreview = this.uploadedImage;
    },
  },
  methods: {
    handleUploadImage(event) {
      this.imageSizeError = '';
      const input = event.target.files[0];
      this.imageFile = input;
      if (input && input.size > appConfig.max_upload_size_per_file) {
        let size = input.size / (1020 * 1024);
        this.imageSizeError = `File size must be less than 2mb. current
        file size: ${size.toFixed(2)} mb`;
      }
      if (input) {
        const reader = new FileReader();
        reader.onload = e => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(input);
      }
      this.$emit('onImageUpload', event, this.imageFile);
    },
    selectFile(id) {
      const element = document.getElementById(id);
      element.click();
    },
    remove(id) {
      const image = document.getElementById(id);
      image.value = null;
      this.imagePreview = null;
      this.imageFile = null;
      this.$emit('onImageRemove');
    },
  },
};
</script>
